import { styled, SxProps } from '@mui/system';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  'data-testid'?: string;
  fixedWidth?: boolean;
  sx?: SxProps;
}

const ListRowStyled = styled('div')<{ fixedWidth: boolean }>(({ fixedWidth }) => ({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'row',
  alignItems: 'center',
  containerType: 'inline-size',
  containerName: 'list-row',
  '.ListPaperColumn-root': fixedWidth ? { width: '25%' } : {},
  '@container (width < 600px)': {
    '.ListPaperColumn-root:nth-of-type(n+3)': {
      display: 'none',
    },
    '.ListPaperColumn-root': {
      width: 'auto',
      flex: 1,
      display: 'block',
      minWidth: 0,
      '&:not(:last-child)': {
        marginRight: '16px',
      },
    },
  },
  '@container (width < 400px)': {
    '.ListPaperColumn-root:nth-of-type(n+2)': {
      display: 'none',
    },
    '.ListPaperColumn-root': {
      width: 'auto',
      flex: 1,
      display: 'block',
      minWidth: 0,
    },
  },
}));

export const ListRow: FC<Props> = ({ children, fixedWidth = true, sx, ...props }) => {
  return <ListRowStyled sx={sx} data-testid={props['data-testid']} fixedWidth={fixedWidth}>{children}</ListRowStyled>;
};
